import Divider from '@mui/material/Divider'
import React from 'react'
import FormattedPrice from '@components/FormattedPrice'
import { useTranslation } from 'react-i18next'
import PackageIcon from '@icons/PackageIcon'
import BoxIcon from '@icons/BoxIcon'
import CheckCircleIcon from '@icons/CheckCircleIcon'

interface KitIncludesItem {
  pk: number
  name: string
  quantity: number
  price: number
}

interface Props {
  items: KitIncludesItem[]
  totalPrice: number
  currency: string
}

const KitIncludes: React.FC<Props> = ({ items, totalPrice, currency }) => {
  const { t } = useTranslation()

  if (!items.length) return null

  return (
    <div className='rounded-lg bg-green-100 p-10'>
      <div className='flex items-center gap-15 mb-20 mt-10'>
        <span className='flex items-center justify-center w-32 h-32 rounded flex-shrink-0'>
          <BoxIcon className='text-secondary' viewBox='0 -960 960 960' style={{ fontSize: '40px' }} />
        </span>
        <span className='font-bold text-xl'>{t('title.yourKitIncludes', 'Your Kit Includes')}</span>
      </div>
      <ul className='list-none m-0 px-5 flex flex-col gap-10'>
        {items.map(item => (
          <li key={item.pk} className='flex items-start justify-between gap-10 text-base'>
            <span className='flex items-start gap-10 min-w-0'>
              <CheckCircleIcon viewBox='0 -960 960 960' className='text-green-light flex-shrink-0' fontSize='small' />
              <span>
                {item.name}&nbsp;{t('xQtyPcs', { defaultValue: 'x {{quantity}}pcs', quantity: item.quantity })}
              </span>
            </span>
            <span className='flex-shrink-0'>
              <FormattedPrice amount={item.price} currency={currency} />
            </span>
          </li>
        ))}
      </ul>
      <div className='my-20 px-5'>
        <Divider />
      </div>
      <div className='flex items-center justify-between px-5 mb-10'>
        <span className='text-base flex items-center gap-10'>
          <PackageIcon className='text-secondary' viewBox='0 -960 960 960' />
          {t('componentsWithCount', {
            defaultValue: '{{count}} components',
            count: items.length,
          })}
        </span>
        <span className='text-2xl font-bold'>
          <FormattedPrice amount={totalPrice} currency={currency} />
        </span>
      </div>
    </div>
  )
}

export default KitIncludes
